import { useMemo } from 'react';
import {
  CATEGORY_ISSUES_MODEL,
  CATEGORY_ISSUES_TABLE_MODEL
} from './category.issues.model';
import usePmProvider from 'components/hooks/PM/usePmProvider';
import { PM_PROVIDERS } from 'common/constants/constants';

const useCols = () => {
  const pmProvider = usePmProvider();

  const cols = useMemo(() => {
    return [
      {
        dataPoint: CATEGORY_ISSUES_TABLE_MODEL.TYPE_CELL,
        name: 'TYPE',
        sortPoint: CATEGORY_ISSUES_MODEL.TYPE.NAME,
        isSortedCol: true,
        tableCellProps: { style: { width: '5%' } }
      },
      ...(pmProvider === PM_PROVIDERS.JIRA
        ? [
            {
              dataPoint: CATEGORY_ISSUES_TABLE_MODEL.KEY_CELL,
              name: 'KEY',
              tableCellProps: { style: { width: '15%' } }
            }
          ]
        : []),
      {
        dataPoint: CATEGORY_ISSUES_TABLE_MODEL.TITLE_CELL,
        name: 'NAME'
      },
      {
        dataPoint: CATEGORY_ISSUES_TABLE_MODEL.ASSIGNEE_CELL,
        name: 'ASSIGNEE',
        sortPoint: CATEGORY_ISSUES_MODEL.ASSIGNEE,
        isSortedCol: true,
        tableCellProps: { style: { width: '15%' } }
      }
    ];
  }, []);
  return cols;
};

export default useCols;
